<template>
  <div class="wrap">
    <div v-if="hasExpired"
         class="expired-msg">
      パスワード再設定リンクの有効期限が切れています。<br />
      新たにリクエストしてください。
    </div>
    <div class="caption">
      蔵衛門IDのパスワード再設定用のURLをメールでお送りします。<br />
      ご登録のメールアドレスを入力してください。
    </div>
    <div class="row">
      <ValidationInput field-name="メールアドレス"
                       :valid-rules="mailRules"
                       ref="mailInput">
        <input type="email"
               placeholder="メールアドレス"
               v-model="mail" />
      </ValidationInput>
    </div>
    <div v-if="hasError" class="err-msg">
      処理に失敗しました
    </div>
    <div class="btn-wrap">
      <button class="btn next-btn"
              @click="requestReset"
              :disabled="!isValid()">
        次へ
      </button>
    </div>    
  </div>
</template>

<script>
import ValidationInput from '@/components/ui/ValidationInput.vue'

export default {
  name: 'Form',
  components: {
    ValidationInput
  },
  props: {
    req: Object
  },
  data() {
    return {
      mail: '',
      mailRules: {
        required: true,
        email: true
      },
      hasExpired: false,
      hasError: false
    }
  },
  methods: {
    requestReset() {
      this.hasExpired = false;
      this.hasError = false;
      const args = {
        mail: this.mail,
        __apiOptions: { noErrorDialog: true }
      }
      this.$store.dispatch('api/sendKuraemonIdPasswordResetMail', args).then(() => {
        if (this.$store.getters['api/apiError']) {
          this.hasError = true;
          return;
        }
        this.req.editState = 'checked';
        this.$router.replace({ name: 'request-password-reset-complete' })
      })
    },
    isValid() {
      if (!this.$refs.mailInput) return;
      return this.$refs.mailInput.$children[0].flags.valid;
    }
  },
  created() {
    if (this.$route.query.expired) {
      // 有効期限切れでリダイレクトしてきた
      this.hasExpired = true;
    }
  }
}
</script>

<style scoped>
.wrap {
  width: 500px;
  margin: auto;
  padding: 1rem;
  text-align: center;
}
.caption {
  font-size: 1.4rem;
  font-weight: bold;
  margin: 4rem 0 3rem 0;
  padding: 0 1rem;
  text-align: left;
}
.row {
  margin: 1rem 0;
}
input {
  border: solid 1px #333;
  border-radius: 0.5rem;
  padding: 0.75rem 0.5rem;
  width: 100%;
}
.btn-wrap {
  margin-top: 3rem;
  text-align: center;
}
.btn {
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem;
  width: 17rem;
}
.next-btn {
  background-color: #333;
  color: white;
}
.next-btn:disabled {
  background-color: #999;
  color: #ccc;
}
.err-msg {
  color: crimson;
  font-size: 0.9rem;
  margin: 1rem auto;
  padding: 1rem;
  text-align: center;
  width: 80%;
}
.expired-msg {
  color: crimson;
  font-size: 1.1rem;
  margin-bottom: -3rem;
  padding: 1rem;
  text-align: left;
}
@media (max-width: 1024px) {
  .wrap {
    max-width: 500px;
    width: 80%;
  }
}
</style>